module.exports = __webpack_public_path__ + "img/success_2.bd93cf21.gif";